export const demandDaysSelector = state => state.demandDaysReducer;
